// QL-375 group 9 — read-only display of the mandate orders QP sent the bank at
// flow completion, grouped by flow instance. One order is one goal's complete
// new mandate: its lines and the accounts it covers. Orders are QP-created and
// bank-updated (optional status callback); this surface never edits. Same
// layout as the Orders tab: a collapsible card per completed advice, a status
// filter and Refresh (shared components in components/orders).

export const T = {
  en_GB: {
    empty:
      "No mandate orders yet. They are created when an advice proposing a new mandate is completed.",
    noOrdersFilter: "No mandate orders match the selected filter.",
    pendingMandate: "awaiting bank",
    activeMandate: "established",
    replaces: (id: string) => `replaces ${id}`,
    // QL-664 — what the order does to the client's mandate.
    originUpdated: "Updated",
    originCreated: "Created",
    modeFixed: "Fixed weights",
    modeMinMax: "Min/max weights",
    lines: (count: number) => `${count} instruments`,
    instrument: "Instrument",
    isin: "ISIN",
    weight: "Weight",
    min: "Min",
    defaultW: "Default",
    max: "Max",
    accounts: "Accounts",
    noAccounts: "No accounts yet — opened by the bank",
    externalOrder: "Bank ref.",
    order: "mandate order",
    orders: "mandate orders",
  },
  nb_NO: {
    empty:
      "Ingen mandatordrer ennå. De opprettes når en rådgivning som foreslår et nytt mandat fullføres.",
    noOrdersFilter: "Ingen mandatordrer samsvarer med det valgte filteret.",
    pendingMandate: "venter på bank",
    activeMandate: "etablert",
    replaces: (id: string) => `erstatter ${id}`,
    originUpdated: "Oppdatert",
    originCreated: "Opprettet",
    modeFixed: "Faste vekter",
    modeMinMax: "Min/maks-vekter",
    lines: (count: number) => `${count} instrumenter`,
    instrument: "Instrument",
    isin: "ISIN",
    weight: "Vekt",
    min: "Min",
    defaultW: "Standard",
    max: "Maks",
    accounts: "Kontoer",
    noAccounts: "Ingen kontoer ennå — opprettes av banken",
    externalOrder: "Bankref.",
    order: "mandatordre",
    orders: "mandatordrer",
  },
} as const;
